<template>
  <div>
    <app-header title="控制台计费"></app-header>
    <div class="center">
      该系统正在开发中
    </div>
  </div>
</template>

<script>
import AppHeader from 'components/app-header';

export default {
  components: {
    AppHeader
  }
}
</script>


<style lang="scss" scoped>
.center {
  padding-top: 200px;
  text-align: center;
  font-size: 16px;
  color: #f90;
}
</style>

